import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { fcmToken } from "../components/redux/action";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_APIKEY,
    authDomain: process.env.REACT_APP_AUTHDOMAIN,
    projectId: process.env.REACT_APP_PROJECTID,
    storageBucket: process.env.REACT_APP_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_APPID,
    measurementId: process.env.REACT_APP_MEASUREMENTID
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

const VAPID_KEY = process.env.REACT_APP_VAPID_KEY;

export const requestPermissionAndGetToken = async (dispatch) => {
    try {
        const permission = await Notification.requestPermission();

        if (permission !== "granted") {
            throw new Error('Notification permission not granted');
        }

        if (!("serviceWorker" in navigator)) {
            console.error("❌ Service workers not supported");
        }

        const registration = await navigator.serviceWorker.register(
            "/firebase-messaging-sw.js"
        );

        const token = await getToken(messaging, {
            // vapidKey: VAPID_KEY,
            serviceWorkerRegistration: registration,
        });

        if (token) {
            // console.log("✅ FCM Token:", token);
            dispatch(fcmToken(token));
        }
    } catch (err) {
        console.error("FCM error:", err);
    }
};
